import http from "../http-common";
const getAll = (vehicle) => {
  const params = {};
  if (vehicle) params.vehicle = vehicle;
  return http.get("/vehicle-repairs", { params });
};
const createNewVehicleRepair = (data) => {
	return http.post('/vehicle-repairs', data);
};
const updateVehicleRepair = (id, data) => {
	return http.put(`/vehicle-repairs/${id}`, data);
};
const deleteVehicleRepair = (id) => {
	return http.delete(`/vehicle-repairs/${id}`);
};

export const VehicleRepairService = {
  getAll,
  createNewVehicleRepair,
  updateVehicleRepair,
  deleteVehicleRepair
};
